import React from 'react';

import { StyleSystemProps, TextV2 } from '@withjoy/joykit';

import { CookedProduct } from '@apps/registry/common/selectors/ProductListSelector';

import { StyledFlex } from './InReceiptItem.styles';
import { ItemBase, ItemBaseVariant } from './ItemBase';
import { useTranslation } from '@shared/core';

type InReceiptItemProps = Readonly<{
  product: Partial<CookedProduct>;
  quantity: number;
  totalPrice: string;
  price: string;
  isDonationFundItem: boolean;
  productPhotoStyles?: StyleSystemProps;
  siteName?: string | null;
  compact?: true;
  variant?: ItemBaseVariant;
  sm?: boolean;
}>;

export const InReceiptItem: React.FC<InReceiptItemProps> = ({ product, quantity, price, totalPrice, isDonationFundItem, siteName, compact, variant, sm, productPhotoStyles }) => {
  const css = compact ? { border: 'none' } : {};
  const { t } = useTranslation('guestRegistry');
  const { quantity: quantityText } = t('confirmationPage');

  return (
    <ItemBase
      registryItemId={product.registryItemId}
      product={product}
      siteName={siteName}
      __css={css}
      variant={variant}
      productPhotoStyles={productPhotoStyles}
    >
      <StyledFlex>
        {!isDonationFundItem && (
          <TextV2
            typographyVariant={sm ? 'label2' : 'body1'}
            color={'mono12'}
            fontFamily="Inter UI"
          >{`${price} x ${quantityText()} ${quantity}`}</TextV2>
        )}
        <TextV2
          textAlign="center"
          typographyVariant={sm ? 'label5' : 'hed1'}
          fontFamily="Inter UI"
        >
          {totalPrice}
        </TextV2>
      </StyledFlex>
    </ItemBase>
  );
};
